import "./PrivacyPolicy.scss";

export default function PrivacyPolicy() {
  return (
    <main className="privacy-policy">
      <div className="privacy-container">
        <h1><b>Privacy Policy</b></h1>
        <p className="updated">Last updated: January 2026</p>

        <section>
          <p>
            Magnifica Choir menghargai privasi Anda dan berkomitmen untuk
            melindungi informasi pribadi yang Anda berikan kepada kami.
          </p>
        </section>

        <section>
          <h2>Informasi yang Kami Kumpulkan</h2>
          <ul>
            <li>Nama</li>
            <li>Alamat email</li>
            <li>Nomor telepon</li>
            <li>Informasi acara</li>
            <li>Pesan atau pertanyaan</li>
          </ul>
        </section>

        <section>
          <h2>Cara Pengumpulan Data</h2>
          <p>
            Data dikumpulkan melalui website, formulir iklan Facebook &
            Instagram, WhatsApp, email, dan komunikasi media sosial.
          </p>
        </section>

        <section>
          <h2>Penggunaan Informasi</h2>
          <ul>
            <li>Menanggapi permintaan layanan</li>
            <li>Komunikasi terkait acara</li>
            <li>Peningkatan kualitas layanan</li>
          </ul>
        </section>

        <section>
          <h2>Pembagian Informasi</h2>
          <p>
            Kami tidak menjual atau membagikan data pribadi kepada pihak ketiga,
            kecuali diwajibkan oleh hukum.
          </p>
        </section>

        <section>
          <h2>Keamanan Data</h2>
          <p>
            Kami menerapkan langkah-langkah keamanan yang wajar untuk melindungi
            data pribadi Anda.
          </p>
        </section>

        <section>
          <h2>Hak Pengguna</h2>
          <p>
            Anda dapat meminta akses, koreksi, atau penghapusan data pribadi Anda
            kapan saja.
          </p>
        </section>

        <section>
          <h2>Cookie & Iklan</h2>
          <p>
            Website ini dapat menggunakan cookie dan teknologi pelacakan untuk
            mendukung efektivitas iklan Meta (Facebook & Instagram).
          </p>
        </section>

        <section>
          <h2>Kontak</h2>
          <p>
            Untuk pertanyaan terkait privasi, silakan hubungi Magnifica Choir
            melalui website resmi kami.
          </p>
        </section>
      </div>
    </main>
  );
}
